module.exports = __webpack_public_path__ + "img/r3sf.2efcb101.png";